import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";
import {_hideModal, _hideSpinner, _setCpToken, _setLang, _showModal, _showSpinner, _verifyOtpAndGetUserDetail} from "../store/system/service";
import useConfig from "../components/qnect-ui/qnect-config";
import Login from "../components/login/login";
import {_getUser, _resetPassword, _storeUser, _verifyEmail} from "../store/user/service";
import * as TagManager from "react-gtm-module";
import ResetOtpDialog from "../components/reset/reset-otp-dialog";
import {customReplaceAll} from "../utils/utility";
import ResetPassword from "../components/reset/reset-password";
import LinkValidationModal from "../components/link-validation-modal";


const RegistrationPage = (props) => {
    const params = new URLSearchParams(props.history.location.search);
    const [loading, setLoading] = useState( false );
    const [verifyTokenCalled, setVerifyTokenCalled] = useState(false);
    const [verifyOpen, setVerifyOpen] = useState(false);
    const [maskedEmail, setMaskedEmail] = useState("");
    const [otpValue, setOtpValue] = useState("");
    const [otpErrorMessage, setOtpErrorMessage] = useState("");
    const [openLinkValidation, setOpenLinkValidation] = useState(false);
    const [linkValidationMessageKey, setLinkValidationMessageKey] = useState("invalidLink");
    const [passwordMinLength, setPasswordMinLength] = useState();
    const [passwordLimit, setPasswordLimit] = useState();

    const cfg = useConfig();

    if (!loading) {
        setLoading(true);
    }

    useEffect(() => {
        if (verifyTokenCalled) {
            let token = params.get('token');
            let iv = params.get('iv');

            props.showSpinner();
            console.log("verify email");

            props.verifyEmail(token, iv).then((response) => {
                if (response.status === 'SUCCESS') {
                    let emailAddress = response.email;
                    props.user.email = emailAddress
                    props.storeUser(props.user);
                    props.setCpToken(response.token);
                    console.log("verify email success");

                    let val = emailAddress.split('@')[0];
                    let regexToUse = val.length > 4 ? /^.*(?=....@)/g : /^.*(?=@)/g;
                    let emailMasked = customReplaceAll(regexToUse, emailAddress, '•');
                    setMaskedEmail(emailMasked);
                    setVerifyOpen(true);

                    TagManager.dataLayer({
                        dataLayer: {
                            event: 'popup',
                            popupPath: '/login',
                            popupTitle: 'Verification Success'
                        }
                    });


                } else if (response.status === 'LINK_EXPIRED') {

                    TagManager.dataLayer({
                        dataLayer: {
                            event: 'popup',
                            popupPath: '/login',
                            popupTitle: 'Verification link is expired'
                        }
                    });

                    setLinkValidationMessageKey('expiredRegistrationLink');
                    setOpenLinkValidation(true);
                } else {

                    TagManager.dataLayer({
                        dataLayer: {
                            event: 'popup',
                            popupPath: '/login',
                            popupTitle: 'Verification link is invalid'
                        }
                    });

                    setLinkValidationMessageKey('invalidLink');
                    setOpenLinkValidation(true);
                }
                props.hideSpinner();
            }, () => {

                TagManager.dataLayer({
                    dataLayer: {
                        event: 'popup',
                        popupPath: '/login',
                        popupTitle: 'Verification link is invalid'
                    }
                });

                setLinkValidationMessageKey('invalidLink');
                setOpenLinkValidation(true);
                props.hideSpinner();
            });

        }
    }, [verifyTokenCalled]);

    const handleLoginRedirection = () => {
        props.history.push('/login');
        props.hideModal();
    }

    const handleVerifyOtp = () => {
        props.showSpinner();
        props.verifyOtpAndGetUserDetail(otpValue, props.user.email).then((response) => {
            if (response.success) {
                props.setCpToken(response.token);
                setVerifyOpen(false);
                props.hideSpinner();
                setPasswordMinLength(response.passwordMinLength);
                setPasswordLimit(response.passwordLimit);
            } else {
                props.hideSpinner();
                setOtpErrorMessage(cfg("otp.errorMessages.invalidOTP"));
            }
        }, () => {
            props.hideSpinner();
            setOtpErrorMessage(cfg("otp.errorMessages.invalidOTP"));
        })
    }

    if (params.get('token')) {
        if (!verifyTokenCalled) {
            setVerifyTokenCalled(true);
        }
        return (
            <>
                <ResetPassword props={props}
                               passwordMinLength={passwordMinLength}
                               passwordLimit={passwordLimit}/>

                <ResetOtpDialog
                    open={verifyOpen}
                    maskedEmail={maskedEmail}
                    onClose={() => setVerifyOpen(false)}
                    onConfirm={handleVerifyOtp}
                    value={otpValue}
                    setValue={setOtpValue}
                    errorMessage={otpErrorMessage}
                    setOtpErrorMessage={setOtpErrorMessage}
                    cfg={cfg}
                    lang={props.lang}
                />

                <LinkValidationModal
                    open={openLinkValidation}
                    messageKey={linkValidationMessageKey}
                    onClose={handleLoginRedirection}
                />
            </>
        );
    } else {
        return (
            <React.Fragment>
                {
                    (!props.match.params.section && <Login/>)
                }
            </React.Fragment>
        )
    }

}


const mapStateToProps = (state) => {
    return {
        user: _getUser(state)
    }
}

const mapDispatchToProps = {
    setLang: _setLang,
    verifyEmail: _verifyEmail,
    verifyOtpAndGetUserDetail: _verifyOtpAndGetUserDetail,
    storeUser: _storeUser,
    setCpToken: _setCpToken,
    showSpinner: _showSpinner,
    hideSpinner: _hideSpinner,
    showModal: _showModal,
    hideModal: _hideModal,
    resetPassword: _resetPassword
}

export default connect(mapStateToProps, mapDispatchToProps)(RegistrationPage);
